export default __webpack_public_path__ + "static/media/310px-190px-square-PMR-Dev-no-border.jpg.e81783ff.webp";